// extracted by mini-css-extract-plugin
export default {"downloadCvLink":"CvLink_downloadCvLink__vp0cL"};